import Modal from 'components/Modal'
import IcashDonationTx from 'views/MemberProfile/ManualTx/IcashDonationTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIcashDonationTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <IcashDonationTx onClose={onClose} />
    </Modal>
  )
}

export default ModalIcashDonationTx
